import moment from 'moment';
import parseDms from './parseDms';

function _formatDateTime(value) {
  return value == null
    ? ''
    : moment
        .utc(value)
        .local()
        .format('DD-MM-YYYY  HH:mm');
}

export default {
  formatBoolean(value) {
    return value ? 'Ja' : 'Nee';
  },

  formatDate(value) {
    return value == null
      ? ''
      : moment
          .utc(value)
          .local()
          .format('DD-MM-YYYY');
  },

  formatDateTime(value) {
    return _formatDateTime(value);
  },

  formatTimeStamp(value) {
    return _formatDateTime(value);
  },

  formatMoney(value) {
    if (value === null) {
      return '';
    } else {
      return '€' + value;
    }
  },

  formatCoordinates(value) {
    try {
      return parseDms(value);
    } catch (error) {
      return null;
    }
  }
};
